<template>
    <div>
        <v-row>
            <v-col cols="3">
                <h1 class="headline font-weight-light mb-3">
                    SRFR Scrap
                </h1>
            </v-col>

            <v-col cols="9" class="text-right">
                <v-btn
                    v-if="team_name != 'PSG' && team_name != 'BENCH RAMA3'"
                    small
                    rounded
                    color="primary"
                    @click="open_new_scrap()"
                >
                    <v-icon small>mdi-plus</v-icon>
                    New Scrap
                </v-btn>
                <v-btn
                    v-else
                    small
                    rounded
                    color="warning"
                    @click="request_scrap()"
                >
                    <v-icon small>mdi-bell</v-icon>
                    Request for Scrap
                </v-btn>
                <v-btn
                    class="ml-3"
                    small
                    :loading="loading_export"
                    rounded
                    color="success"
                    @click="export_data_scrap()"
                >
                    <v-icon small>mdi-download</v-icon>
                    Export Data
                </v-btn>

                <v-btn
                    v-if="
                        team_name == 'PSG' ||
                            team_name == 'BENCH RAMA3' ||
                            team_name == 'ODM'
                    "
                    class="ml-3"
                    small
                    rounded
                    color="grey lighten-2"
                    @click="dialog_history = true"
                >
                    <v-icon small>mdi-history</v-icon>
                    History Sent Scrap
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center" rowspan="2">#</th>
                                <th class="text-center" rowspan="2">
                                    Branch
                                </th>
                                <th class="text-center" colspan="2">
                                    @ SVC
                                </th>
                                <th class="text-center" colspan="2">
                                    Transfer
                                </th>
                                <th class="text-center" colspan="2">
                                    @ BKK
                                </th>
                            </tr>
                            <tr class="col-tr-1">
                                <th class="text-center">Units</th>
                                <th class="text-center">Kg.</th>
                                <th class="text-center">Units</th>
                                <th class="text-center">Kg.</th>
                                <th class="text-center">Units</th>
                                <th class="text-center">Kg.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in data_main" :key="index">
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total'
                                            : 'text-center'
                                    "
                                >
                                    {{
                                        data_main.length != index + 1
                                            ? index + 1 + "."
                                            : ""
                                    }}
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total'
                                            : ''
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p font-b'
                                                : 'cur-p cs-total'
                                        "
                                    >
                                        {{ row.branch_name }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'SVC',
                                                row.SVC
                                            )
                                        "
                                    >
                                        {{ row.SVC }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'SVC',
                                                row.SVC
                                            )
                                        "
                                    >
                                        {{ row.SVC_sum }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'Transfer',
                                                row.Transfer
                                            )
                                        "
                                    >
                                        {{ row.Transfer }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'Transfer',
                                                row.Transfer
                                            )
                                        "
                                    >
                                        {{ row.Transfer_sum }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'BKK',
                                                row.BKK
                                            )
                                        "
                                    >
                                        {{ row.BKK }}
                                    </span>
                                </td>
                                <td
                                    :class="
                                        data_main.length == index + 1
                                            ? 'bg-total text-right'
                                            : 'text-right'
                                    "
                                >
                                    <span
                                        :class="
                                            data_main.length != index + 1
                                                ? 'cur-p'
                                                : 'cur-p cs-total'
                                        "
                                        @click="
                                            detail(
                                                row.branch_id,
                                                'BKK',
                                                row.BKK
                                            )
                                        "
                                    >
                                        {{ row.BKK_sum }}
                                    </span>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">New Scrap</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row v-if="search.step == 1">
                            <v-col cols="12" md="8">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Search / Enter"
                                    v-model="search.search"
                                    v-on:keyup.enter="search_new_scrap()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="search.step == 2">
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Case ID"
                                    v-model="data_search.case_id"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Product Serial"
                                    v-model="data_search.product_serial"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Product No"
                                    v-model="data_search.product_no"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Product Description"
                                    v-model="data_search.product_description"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Weight"
                                    v-model="data_search.weight"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Box Size"
                                    v-model="data_search.box_size"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="close_new_scrap()"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        rounded
                        v-if="search.step == 2"
                        @click="save_new_scrap()"
                    >
                        <v-icon small class="mr-1">mdi-content-save</v-icon>
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_detail"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_dialog_detail()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <ScrapDetail :form="form" @scrapPage="getScrap()" />
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_history"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_dialog_history()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <ScrapHistory />
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar color="success" v-model="snackbar" :timeout="timeout">
            Send alert to SVC for request scrap already.
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import axios from "axios"
import ScrapDetail from "./Detail.vue"
import ScrapHistory from "./History.vue"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        ScrapDetail,
        ScrapHistory,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "scrap/list", this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_main = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        detail(branch, st, num) {
            if (num > 0) {
                this.form = {
                    branch_id: branch,
                    status: st,
                }
                this.dialog_detail = true
            }
        },
        close_dialog_detail() {
            this.form = {
                branch_id: 0,
                status: "",
            }
            this.dialog_detail = false
        },
        close_dialog_history() {
            this.dialog_history = false
        },
        open_new_scrap() {
            this.dialog = true
        },
        request_scrap() {
            this.$swal({
                title: "Request scrap from SVC ?",
                text: "เรียกขอ Scrap จาก SVC เลยหรือไม่ ?",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .get(url + "scrap/request", this.tk)
                        .then((response) => {
                            // this.close()
                            this.snackbar = true
                            // this.get_data()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        close_new_scrap() {
            this.search = {
                step: 1,
                search: "",
            }
            this.form_search = {
                case_id: "",
                product_serial: "",
                product_no: "",
                product_description: "",
                weight: "",
                box_size: "",
            }
            this.dialog = false
        },
        async search_new_scrap() {
            this.dialog_loading = true
            await axios
                .post(url + "scrap/search", this.search, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_search = response.data
                    this.search.step = 2
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async export_data_scrap() {
            this.loading_export = true

            await axios({
                url: url + "scrap/export",
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.loading_export = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "export.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async save_new_scrap() {
            this.dialog_loading = true
            await axios
                .post(url + "scrap/save", this.data_search, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.close_new_scrap()
                    this.get_data()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getScrap() {
            this.dialog_detail = false
            this.get_data()
        },
    },
    data() {
        return {
            tk: null,
            dialog: false,
            dialog_loading: false,
            dialog_detail: false,
            dialog_history: false,
            data_main: [],
            data_search: [],
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            form: {
                branch_id: 0,
                status: "",
            },
            search: {
                step: 1,
                search: "",
            },
            snackbar: false,
            timeout: 2000,
            loading_export: false,
        }
    },
}
</script>
<style scoped>
.cs-total {
    font-weight: bold;
    color: rgb(6, 60, 121);
}
.cs-total:hover {
    font-weight: bold;
    color: rgb(67, 206, 39);
}
.bg-total {
    background-color: rgb(224, 236, 255);
}
</style>
